export function formatBps(bps: number, percentCalculatedIn = false) {
  return `${getBpsPercent(bps, percentCalculatedIn)}%`
}

export function getBpsPercent(bps: number, percentCalculatedIn = true) {
  return bps / (10000 / (percentCalculatedIn ? 1 : 100))
}
